export default "__VITE_ASSET__BKpQd2DK__"